module.exports = __webpack_public_path__ + "media/images/flags/16/Sudan-1c7f6ea0418a385b1b24697d1511577f.png";